// extracted by mini-css-extract-plugin
export default {"link":"MO-z","disabled":"NO-z"};